export enum OrderRelationshipType {
  ON_TIMEOUT,
  NONE,
  OCO,
  IFDONE,
  LOOP,
  GAMMA,
}

export namespace OrderRelationshipType {
  let elements = [
    OrderRelationshipType.ON_TIMEOUT,
    OrderRelationshipType.NONE,
    OrderRelationshipType.OCO,
    OrderRelationshipType.IFDONE,
    OrderRelationshipType.LOOP,
    OrderRelationshipType.GAMMA,
  ];
  let alias = "com.bcdfx.api.model.OrderRelationshipType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
